import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function scrollToHash(hash, { behavior = "smooth" } = {}) {
  const id = (hash || "").replace(/^#/, "");
  if (!id) return false;
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior, block: "start" });
  return true;
}

export function parseHashHref(href) {
  const url = new URL(href, window.location.origin);
  return {
    pathname: url.pathname || "/",
    hash: url.hash,
  };
}

export function isModifiedClick(event) {
  return (
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  );
}

/** Scroll to location.hash after route/hash changes (and on first load). */
export function useScrollToHash() {
  const { pathname, hash } = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (!hash) {
      isFirst.current = false;
      return undefined;
    }

    const behavior = isFirst.current ? "auto" : "smooth";
    isFirst.current = false;

    let cancelled = false;
    const run = () => {
      if (!cancelled) scrollToHash(hash, { behavior });
    };

    run();
    const frame = requestAnimationFrame(run);
    const timer = window.setTimeout(run, 100);
    return () => {
      cancelled = true;
      cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, [pathname, hash]);
}
